import { Box, Button, CircularProgress, IconButton, MenuItem, Snackbar, TextField, Typography } from '@mui/material';
import Header from '../../../components/Header';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import { useTheme } from '@emotion/react';
import { tokens } from '../../../theme';
import ProgressCircle from '../../../components/ProgressCircle';

const ImportBookings = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastmessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    country: '',
    departureDate: '',
    bookingEndDate: '',
  });
  const [country, setCountry] = useState([]);

  const [file, setFile] = useState(null);

  const token = localStorage.getItem('token');

  const getCountryNames = async () => {
    const res = await fetch(`${process.env.REACT_APP_APILINK}/countrynames`, { headers: { token } });
    const data = await res.json();
    setCountry(data);
  };

  useEffect(() => {
    getCountryNames();
  }, []);

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (file && values.country && values.departureDate) {
      setLoading(true);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('country', values.country);
      formData.append('departureDate', values.departureDate);
      formData.append('bookingEndDate', values.bookingEndDate || '');

      try {
        const res = await fetch(`${process.env.REACT_APP_APILINK}/admin/bookings/import`, {
          headers: { token },
          method: 'POST',
          body: formData,
        });
        const data = await res.json();
        setOpenToast(false);
        if (data.message) {
          setOpenToast(true);
          setToastmessage(data.message);
          if (data.success) {
            setTimeout(() => {
              navigate(`/booking`);
            }, 2000);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    setLoading(false);
  };

  // Toast
  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenToast(false);
  };

  const action = (
    <>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseToast}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  const handleDownloadSample = () => {
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL || ''}/booking-import-sample.csv`;
    link.download = 'booking-import-sample.csv';
    link.click();
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center" rowGap="10px" flexWrap="wrap-reverse">
        <Header title="IMPORT BOOKINGS" subtitle="Import Booking Details using Excel or CSV" />

        <Box>
          <Link to={-1}>
            <Button
              sx={{
                backgroundColor: colors.blueAccent[700],
                color: colors.grey[100],
                fontSize: '14px',
                fontWeight: 'bold',
                padding: '10px 20px',
                '&:hover': {
                  backgroundColor: colors.blueAccent[800],
                },
              }}
            >
              Go Back
            </Button>
          </Link>
        </Box>
      </Box>

      <form onSubmit={handleSubmit}>
        <Box display="flex" flexDirection="column" gap="10px">
          {/* Location / Destination */}
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Destination"
            onChange={handleChange}
            value={values.country}
            name="country"
            select
            required
          >
            {country &&
              country.map((country) => (
                <MenuItem key={country.CountryID} value={country.CountryID}>
                  {country.CountryName}
                </MenuItem>
              ))}
          </TextField>

          <TextField
            fullWidth
            variant="filled"
            type="date"
            label="Departure Date"
            onChange={handleChange}
            value={values.departureDate}
            name="departureDate"
            InputLabelProps={{ shrink: true, style: { color: colors.grey[300] } }}
            style={{ colorScheme: 'dark' }}
            required
          />

          <TextField
            fullWidth
            variant="filled"
            type="date"
            label="Booking End Date"
            onChange={handleChange}
            value={values.bookingEndDate}
            name="bookingEndDate"
            InputLabelProps={{ shrink: true, style: { color: colors.grey[300] } }}
            style={{ colorScheme: 'dark' }}
          />

          <Box
            sx={{
              py: 2.5,
              px: 2.5,
              borderRadius: 2,
              background: `linear-gradient(135deg, ${colors.primary[400]} 0%, ${colors.primary[600]} 100%)`,
              border: `1px solid ${colors.blueAccent[600]}`,
              boxShadow: `0 4px 20px ${colors.primary[900]}`,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                mb: 1,
                color: colors.blueAccent[300],
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
              }}
            >
              Sample file format
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: colors.grey[200], lineHeight: 1.6 }}>
              Download the sample file to ensure correct format. Columns: No., Destination, HOTEL, NAME, SURNAME, Gender, Bus No, Date of birth, PASSEPORT, TELEFON, MAIL, ID no of Resrvation, Reservation date, PARTNER, Departure Place, Remark, Guide.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: colors.grey[100], lineHeight: 1.6, fontSize: '1rem' }}>
              <strong>Notes: (import booking) -</strong> If the <strong>MAIL</strong> field is empty:
              <br />
              <span style={{ display: 'inline-block', marginTop: '6px', color: colors.grey[300], fontWeight: 700 }}>
                Login Details:
              </span>
              <br />
              <span style={{ fontSize: '0.95rem' }}>
                <span style={{ color: colors.blueAccent[300], fontWeight: 700 }}>Default email:</span>{' '}
                <strong>name.surname@rapsody.com</strong>
              </span>
              <br />
              <span style={{ fontSize: '0.95rem' }}>
                <span style={{ color: colors.blueAccent[300], fontWeight: 700 }}>Password:</span>{' '}
                <strong>Reservation ID (Contract ID)</strong>
              </span>
            </Typography>
            <Button
              variant="contained"
              size="small"
              startIcon={<DownloadIcon sx={{ fontSize: 18 }} />}
              onClick={handleDownloadSample}
              sx={{
                backgroundColor: colors.greenAccent[600],
                color: colors.grey[100],
                fontWeight: 600,
                fontSize: '12px',
                px: 2,
                py: 1,
                borderRadius: 1.5,
                '&:hover': {
                  backgroundColor: colors.greenAccent[500],
                },
              }}
            >
              Download Sample CSV
            </Button>
          </Box>

          <label
            htmlFor="file"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              padding: '15px 30px',
              background: colors.primary[400],
              fontSize: '18px',
              fontWeight: 'bold',
              cursor: 'pointer',
              borderRadius: '10px',
            }}
          >
            <CloudUploadIcon /> {file ? file.name : 'Choose file*'}
          </label>
          <input type="file" accept=".xlsx, .xls, .csv" id="file" onChange={(e) => setFile(e.target.files[0])} hidden />
          <Button
            type="submit"
            disabled={loading}
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.grey[100],
              width: 'fit-content',
              fontSize: '14px',
              fontWeight: 'bold',
              padding: '10px 30px',
              '&:hover': {
                backgroundColor: colors.blueAccent[800],
              },
            }}
          >
            {loading ? (
              <>
                <CircularProgress color="secondary" size="20px" sx={{ marginRight: '10px' }} />
                Uploading
              </>
            ) : (
              'Upload File'
            )}
          </Button>
        </Box>
      </form>

      <Snackbar
        open={openToast}
        autoHideDuration={5000}
        onClose={handleCloseToast}
        message={toastMessage}
        action={action}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </Box>
  );
};

export default ImportBookings;
